import { render, staticRenderFns } from "./AddSitesOrg.vue?vue&type=template&id=7f2200f2"
import script from "./AddSitesOrg.vue?vue&type=script&lang=js"
export * from "./AddSitesOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports